<template>
  <div class="taoBao">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 目录 -->
    <div class="content-list">
      <el-tabs
        v-model="mydata.activeName"
        class="demo-tabs"
        @tab-click="handleClick"
      >
        <el-tab-pane label="公司介绍" name="first">
          <companyIntroOne :key="mydata.myKey3"></companyIntroOne>
        </el-tab-pane>
        <el-tab-pane label="发展历程" name="second">
          <developmentHistoryTwo></developmentHistoryTwo>
        </el-tab-pane>
        <el-tab-pane label="联系我们" name="third">
          <!-- 这里必须使用v-if指令，否则地图的信息弹窗无法显示出来 -->
          <contactUsThree v-if="mydata.activeName === 'third'"></contactUsThree>
        </el-tab-pane>
        <el-tab-pane label="诚聘英才" name="fourth">
          <joinUsFour :key="mydata.myKey1"></joinUsFour>
        </el-tab-pane>
        <el-tab-pane label="企业动态" name="five">
          <enterpriseDynamicsFive :key="mydata.myKey2"></enterpriseDynamicsFive>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>


<script>
// 是否来自其他模块
let fromOtherModule = false
// 缓存组件
import { defineComponent } from "vue"
export default defineComponent({
  name: 'walkIntroTianLi',
    beforeRouteEnter(to,from,next){    
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if ( ['/layout/list/joinUsDetails','/layout/list/enterpriseDetails'].includes(from.path) === false  ) {
      fromOtherModule = true
      // console.log('来自其他模块');      
    }
    next()
  }
});
</script>






<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import companyIntroOne from "@/views/walkIntroTianLi/components/companyIntroOne/index.vue";
import developmentHistoryTwo from "@/views/walkIntroTianLi/components/developmentHistoryTwo/index.vue";
import contactUsThree from "@/views/walkIntroTianLi/components/contactUsThree/index.vue";
import joinUsFour from "@/views/walkIntroTianLi/components/joinUsFour/index.vue";
import enterpriseDynamicsFive from "@/views/walkIntroTianLi/components/enterpriseDynamicsFive/index.vue";

// import bookBigListenCards from "@/components/bookBigListenCards/index.vue";
// import thematicCards from "@/components/thematicCards/index.vue";
// import { Document } from "@element-plus/icons-vue";

// import researchProjects from "@/components/researchProjects/index.vue";

import { reactive, onActivated } from "vue";

import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  activeName: "first",

  myText: "", //拿到首页传过来的text
  myKey1:new Date().getTime() - Math.random(),
  myKey2:new Date().getTime() - Math.random() * 10,
  myKey3:new Date().getTime() - Math.random() * 100
});


onActivated(() => {
  //拿到首页传过来的text
  mydata.myText = route.query.text;
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  // if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
  if ((fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1)&&!mydata.myText) {
    mydata.activeName = "first";
    mydata.myKey1 = new Date().getTime() - Math.random();
    mydata.myKey2 = new Date().getTime() - Math.random() * 10;
  }else{
    
    //拿到首页传过来的text
    // mydata.myText = route.query.text;

    // 如果路由传递过来的数据是"企业动态"，那么就把tabs插件的激活状态修改为"five'
    if (mydata.myText === "公司介绍") {
      mydata.activeName = "first";
    } else if (mydata.myText === "发展历程") {
      mydata.activeName = "second";
    } else if (mydata.myText === "联系我们") {
      mydata.activeName = "third";
    } else if (mydata.myText === "诚聘英才") {
      mydata.activeName = "fourth";
    } else if (mydata.myText === "企业动态") {
      mydata.activeName = "five";
    } else {
      // mydata.activeName = "first";
    }
  }

      

  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  mydata.myKey3 = new Date().getTime() - Math.random() * 100  
});

//点击事件
function findButton() {
  router.push({
    path: "/layout/list/everyDetails",
  });
}

function handleClick(){
  mydata.myKey1 = new Date().getTime() - Math.random()
  mydata.myKey2 = new Date().getTime() - Math.random() * 10
  mydata.myKey3 = new Date().getTime() - Math.random() * 100
}


</script>

<style scoped lang="scss">
.taoBao {
  background-color: #f9f9f9;
  // padding-bottom: 40px;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }
  ////目录
  .content-list {
    // border: 1px solid red;
    background-color: #ffffff;
    // 目录的内容
    :deep(.demo-tabs > .el-tabs__content) {
      // padding: 30px;
      // border: 1px solid red;
      margin: 0px;
    }
    ////整体目录list
    :deep(.el-tabs__header.is-top) {
      // width:1200px;
      height: 44px;
      margin-bottom: 0px;
      // border:1px solid red;
      display: flex;
      justify-content: center;
    }

    //////每个字体
    :deep(.el-tabs__item.is-top) {
      // width: 64px;
      // height: 32px;
      text-align: center;
      padding: 5px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      // border:1px solid red;
    }

     //激活状态时得字体
    :deep(.el-tabs__item.is-top.is-active){
      color: #409EFF;
      font-weight: 700;
    }
    // :deep(.el-tabs__item.is-top:hover) {
    //   color: #333333;
    // }
    ///////整体宽度的宽度
    :deep(.el-tabs__nav.is-top) {
      // border: 1px solid rgb(0, 255, 0);
      // width: 1915px;
      // width: 1200px;
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
    }
    // :deep(.el-tabs__nav.is-top::after){
    //   height:0px !important;
    // }

    // :deep(.el-tabs__nav-scroll::after){
    //   width:1915px !important;
    // }
    :deep(.el-tabs__nav-scroll) {
      // border:1px solid blue;
      width: 375px;
      display: flex;
      justify-content: center;
    }
    // 目录内容
    :deep(.demo-tabs > .el-tabs__content) {
      // padding: 30px;
      // width: 860px;
      // // height: 634px;
      // border: 1px solid red;
      // background-color: #ffffff;
    }
  }
}
</style>
